import { toast } from 'vue3-toastify'

export interface ToastMessage {
  header: string
  body: string
  color: 'green' | 'red' | ''
}

export function useToast() {
  const showToast = (message: ToastMessage) => {
    const isSuccess = message.color === 'green'
    const toastMessage = `${message.header}\n${message.body}`

    if (isSuccess) {
      toast.success(toastMessage, {
        position: 'top-right',
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        // draggable: true,
        theme: 'light',
        style: {
          fontFamily: 'IRANYekanX',
          fontSize: '10px',
          fontWeight: '500',
          color: '#212121',
          textAlign: 'right',
          direction: 'rtl'
        }
      })
    } else {
      toast.error(toastMessage, {
        position: 'top-right',
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        // draggable: true,
        theme: 'light',
        style: {
          fontFamily: 'IRANYekanX',
          fontSize: '10px',
          fontWeight: '500',
          color: '#212121',
          textAlign: 'right',
          direction: 'rtl'
        }
      })
    }
  }

  const showSuccess = (header: string, body: string) => {
    showToast({ header, body, color: 'green' })
  }

  const showError = (header: string, body: string) => {
    showToast({ header, body, color: 'red' })
  }

  return {
    showToast,
    showSuccess,
    showError
  }
}
